import { useInView } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardSectionNew } from 'shared/components/CardSectionNew';

import { trackShowAllVillagesClick, trackVillageClick, trackVillagesInView } from './tracking';
import { RecommendedVillagesNew } from '../../components/RecommendedVillages';
import { offerSelector } from '../../selectors';
import { selectRecommendedVillages } from '../../selectors/selectRecommendedVillages';

export const RecommendedVillagesContainer = () => {
  const recommendedVillages = useSelector(selectRecommendedVillages);
  const offer = useSelector(offerSelector);
  const villageIds = React.useMemo(
    () => (recommendedVillages ? recommendedVillages.villageList.map(({ id }) => id) : []),
    [recommendedVillages],
  );

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  React.useEffect(() => {
    if (inView) {
      trackVillagesInView(offer, villageIds);
    }
  }, [inView, offer, villageIds]);

  if (!recommendedVillages || !recommendedVillages.villageList.length) {
    return null;
  }

  return (
    <CardSectionNew title="Рекомендуем коттеджные посёлки" subtitle="Охрана, зоны отдыха и удобная инфраструктура">
      <RecommendedVillagesNew
        {...recommendedVillages}
        ref={ref}
        onVillageClick={trackVillageClick}
        onShowAllClick={trackShowAllVillagesClick}
      />
    </CardSectionNew>
  );
};
